import * as actions from '../actions/actionCatalog';

type FileIgnore = {
  popups: {
    showConfirmationPopup: boolean;
  };
};

const defaultPopusState = {
  showConfirmationPopup: false,
};

const FileIgnoreInitialState: FileIgnore = {
  popups: defaultPopusState,
};

type FileIgnoreFulfilled = {
  type: typeof actions.IGNORE_FILE_QUEUED_ITEM_FULFILLED;
};

type FileIgnoreAbort = {
  type: typeof actions.IGNORE_FILE_QUEUED_ITEM_ABORT;
};
type FileIgnorePopup = {
  type: typeof actions.IGNORE_FILE_QUEUED_ITEM_POPUP;
};

type FileIgnoreAction = FileIgnorePopup | FileIgnoreFulfilled | FileIgnoreAbort;

export const fileIgnore = (state: FileIgnore = FileIgnoreInitialState, action: FileIgnoreAction) => {
  switch (action.type) {
    case actions.IGNORE_FILE_QUEUED_ITEM_POPUP:
      return {
        ...state,
        popups: { ...state.popups, showConfirmationPopup: true },
      };
    case actions.IGNORE_FILE_QUEUED_ITEM_FULFILLED:
      return {
        ...state,
        popups: {
          showConfirmationPopup: false,
        },
      };
    case actions.IGNORE_FILE_QUEUED_ITEM_ABORT:
      return { ...state, popups: defaultPopusState };
    default:
      return state;
  }
};
